module.exports = __webpack_public_path__ + "img/AI_icon.3a867d4d.png";